var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17V17.75C13 18.5456 12.6839 19.3087 12.1213 19.8713C11.5587 20.4339 10.7956 20.75 9.99999 20.75C9.20434 20.75 8.44128 20.4339 7.87867 19.8713C7.31606 19.3087 6.99999 18.5456 6.99999 17.75V17M18.0475 15.4733C16.8437 14 15.9939 13.25 15.9939 9.18828C15.9939 5.46875 14.0945 4.14359 12.5312 3.5C12.3236 3.41469 12.1281 3.21875 12.0648 3.00547C11.7906 2.07219 11.0219 1.25 9.99999 1.25C8.97811 1.25 8.20889 2.07266 7.93749 3.00641C7.87421 3.22203 7.67874 3.41469 7.47108 3.5C5.90593 4.14453 4.00842 5.465 4.00842 9.18828C4.00608 13.25 3.15624 14 1.95249 15.4733C1.45374 16.0836 1.89061 17 2.76296 17H17.2417C18.1094 17 18.5434 16.0808 18.0475 15.4733Z",
    stroke: "#83899F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.4e7573d0be5c9d7b617d11bfee366afd.svg";
export { ForwardRef as ReactComponent };